import type { MRecord } from '../util/record'

import { defineArrayProperties } from './array'
import { defineProperty } from './util'

let isInitialized = false
export function extendProperties() {
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
    // console.log(`[${process.env.NODE_ENV}] extendProperties called`)
  }
  if (isInitialized) {
    return
  }
  if (isAlreadyExtended()) {
    return
  }
  defineArrayProperties()
  isInitialized = true
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
    // console.log(`[${process.env.NODE_ENV}] extendProperties finished`)
  }
}

// isInitializedのロジックだけで問題ないはずだったが、
// モノレポ移行後から動作しなくなってしまったので以下のロジックでもチェックする
function isAlreadyExtended(): boolean {
  try {
    defineProperty(Array.prototype, '_buffCommonExtendPropertiesCallledChecker', () => {}, 'Array')
    return false
  } catch (e) {
    return true
  }
}

declare global {
  interface Array<T> {
    groupBy: <Key extends string | number>(f: (x: T) => Key) => MRecord<Record<Key, T[]>>
    groupByUniqueKey: <Key extends string | number>(f: (x: T) => Key) => Record<Key, T>
    countBy: <Key extends string | number>(f: (x: T) => Key) => Record<Key, number>
    /* eslint-disable @typescript-eslint/no-redundant-type-constituents */
    mySortBy: (f: (x: T) => unknown | unknown[]) => T[]
    sortBy: (f: (x: T) => unknown | unknown[]) => T[]

    toObject: <K extends string | undefined, V>(
      f: (x: T, i: number) => [key: K, value: V],
    ) => Record<Exclude<K, undefined>, V>
    toRecord: <V>(f: (x: T, i: number) => [key: string | undefined, value: V]) => MRecord<Record<string, V>>
    unique: () => T[]
    uniqueBy: (f: (x: T) => unknown) => T[]
    zip: <S>(ys: S[]) => Array<[T, S]>
    eachCons: (x: number) => T[][]
    eachSlice: (x: number) => T[][]
    last: () => T | undefined
    first: () => T | undefined
    sum: () => number
    sample: () => T
    compact: () => Array<Exclude<T, null | undefined>>
    min: () => number | undefined // 配列の長さが0のときundefined
    max: () => number | undefined
    minBy: (f: (x: T) => number) => T | undefined
    maxBy: (f: (x: T) => number) => T | undefined
    sliceWhen: (f: (a: T, b: T) => boolean) => T[][]
    partition: (f: (x: T) => boolean) => [trues: T[], falses: T[]]
    isPresent: () => boolean
    isBlank: () => boolean
    isEmpty: () => boolean
    isEqual: (xs: T[]) => boolean
    union: (xs: T[]) => T[]
    intersection: (xs: T[]) => T[]
    difference: (xs: T[]) => T[]
    intersectionBy: <S>(xs: T[], f: (x: T) => S) => T[]
    differenceBy: <S, K>(xs: K[], f: (x: T | K) => S) => T[]
    clone: () => T[]
    upsertBy: (x: T, f: (x: T) => string) => T[]
    move: (oldIndex: number, newIndex: number) => T[]
    combination: (n: number) => T[][]
    subsets: () => T[][]
  }
}
